import { Link } from "react-router-dom";

import { useTheme } from "../../providers/ThemeContext";
import { GlobalStyles } from "../../styles/GlobalStyles";
import { useLangPath } from "../../hooks/useLangPath";

interface Props {
  title?: string;
  buttonLabel: string;
  to?: any;
}

const CallToAction = ({ title, buttonLabel, to }: Props) => {
  const { theme } = useTheme();
  const g = GlobalStyles(theme);
  const lp = useLangPath();

  return (
    <>
      {title && <div style={g.ctaText}>{title}</div>}
      <Link to={to ? to : lp("/contact")} style={g.btnPrimary}>
        {buttonLabel}
      </Link>
    </>
  );
};
export default CallToAction;
